export interface CompanySigningEntity {
  companyAclf: string;
  companyExternalId: string;
  companyId: string;
  companyManagerId: string;
  companyName: string;
  signingEntityName: string;
  isSanctioned?: boolean;
}
